import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, Megaphone } from "lucide-react";

// Banner que aparece en Perfil / Empresas / Redes cuando el usuario llegó
// desde el flujo de creación de campaña, para que regrese y termine de publicar.
export const BackToCampaigns = () => {
  const [params] = useSearchParams();
  if (params.get("from") !== "campana") return null;
  const canal = params.get("canal") || "";
  const to = `/dashboard/campanas?nuevo=1${canal ? `&canal=${canal}` : ""}`;
  return (
    <Link
      to={to}
      data-testid="back-to-campaigns"
      className="mb-6 flex items-center justify-between gap-3 flex-wrap rounded-2xl border border-yellow-400/40 bg-yellow-400/10 px-5 py-3.5 hover:bg-yellow-400/15 transition-colors"
    >
      <span className="flex items-center gap-2 text-sm text-yellow-impact font-semibold">
        <Megaphone size={16} /> Estás configurando tu campaña. Termina este paso y vuelve para publicarla.
      </span>
      <span className="flex items-center gap-1.5 text-sm font-bold text-yellow-impact whitespace-nowrap">
        <ArrowLeft size={15} /> Volver a Campañas
      </span>
    </Link>
  );
};
